import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export const phoneMask = ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
export const dateMask = {
  mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
  pipe: createAutoCorrectedDatePipe("mm/dd/yyyy"),
};
export const einMask = [/\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
export const ubiMask = [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
export const ssnMask = [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
export const zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
// Positive whole numbers.
export const numberMask = createNumberMask({
  prefix: "",
});
export const numberMaskWithoutCommas = createNumberMask({
  prefix: "",
  includeThousandsSeparator: false,
  allowDecimal: true,
});
export const currencyMask = createNumberMask({
  prefix: "$",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ",",
  allowDecimal: true,
  decimalSymbol: ".",
  decimalLimit: 2,
  allowNegative: false,
  allowLeadingZeroes: false,
});
